import {
  ApplicationConfig,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
  inject
} from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { offlineInterceptor } from './core/interceptors/offline.interceptor';
import { sessionExpiryInterceptor } from './core/interceptors/session-expiry.interceptor';
import { NetworkService } from './core/platform/network.service';
import { AppLifecycleService } from './core/platform/app-lifecycle.service';
import { OfflineWriteQueueService } from './core/platform/offline-write-queue.service';
import { SessionWatcherService } from './core/services/session-watcher.service';

export const sharedAppProviders = [
  provideBrowserGlobalErrorListeners(),
  provideZoneChangeDetection({ eventCoalescing: true }),

  provideAppInitializer(async () => {
    const network = inject(NetworkService);
    const lifecycle = inject(AppLifecycleService);
    const writeQueue = inject(OfflineWriteQueueService);
    const sessionWatcher = inject(SessionWatcherService);

    await Promise.allSettled([network.init(), lifecycle.init()]);

    try {
      writeQueue.init();
    } catch (err) {
      console.error('Offline write queue failed to initialise', err);
    }

    try {
      sessionWatcher.init();
    } catch (err) {
      console.error('Session watcher failed to initialise', err);
    }
  }),

  provideHttpClient(
    withInterceptors([authInterceptor, sessionExpiryInterceptor, offlineInterceptor])
  ),
  provideAnimations()
];

export function createAppConfig(extraProviders: ApplicationConfig['providers']): ApplicationConfig {
  return { providers: [...sharedAppProviders, ...extraProviders] };
}
